<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-select v-model="tableParams.onlineStatus" clearable placeholder="状态查询" >
        <el-option label="已下架" :value="0"></el-option>
        <el-option label="已上架" :value="1"></el-option>
      </el-select>
      <el-select v-model="tableParams.isConfig" clearable placeholder="是否配置渠道号" >
        <el-option label="已配置" :value="1"></el-option>
        <el-option label="未配置" :value="2"></el-option>
      </el-select>

      <el-select v-model="tableParams.dspId" clearable filterable  placeholder="请选择DSP名称">
        <el-option v-for="item in dspList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="tableParams.dspSlotName" clearable  placeholder="请选择DSP广告位名称" />
      <el-input v-model="tableParams.apkBundleOrApkName" clearable  placeholder="请选择应用包名/名称" />
      <el-input v-model="tableParams.oppoChannel" clearable  placeholder="请输入渠道号" />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px">
        <el-button @click="
          downExcel(
            '/distOppoAppConfig/list/csv',
            '应用包管理',
            tableParams
          )
        " type="warning" size="small">下载
        </el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%" @sort-change="sortChange">
        <el-table-column v-if="tableParams.isTime" sortable prop="timeHour" label="上报时间" align="center" />
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center" :sortable="
            v.field === 'createTime' ||
            v.field === 'updateTime' ||
            v.field === 'versionCode'
          ">
          <template v-slot="scope">
            <span v-if="
              v.field === 'onlineStatus'
            " type="info">{{ scope.row[v.field] == 0 ? '已下架' : '已上线' }}</span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button @click="configuration(scope.row)" type="success" size="mini">配置</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>

    <m-form @submit="toQuery" ref="form" title="应用包配置" />

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import mForm from './form'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import { getDspName } from '@/api/select'

export default {
  name: 'dsp/user/adAppBag',
  components: {
    TableColumn,
    mForm,
    SearchDspSelect,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'dspName', title: 'DSP名称' },
        { field: 'dspSlotName', title: 'DSP广告位名称' },
        { field: 'apkBundle', title: '应用包名' },
        { field: 'apkName', title: '应用名称' },
        { field: 'oppoChannel', title: '渠道号' },
        { field: 'apkMd5', title: 'MD5' },
        { field: 'price', title: '价格' },
        { field: 'cpuModel', title: 'CPU架构' },
        { field: 'createTime', title: '创建时间' },
        { field: 'updateTime', title: '更新时间' },
        { field: 'onlineStatus', title: '在线状态' },
        { field: 'auditMsg', title: '描述' },
        { field: 'versionCode', title: '版本号' },
      ],
      getDspType: ["cpm", "cpd", "通用"],
      dspList: undefined,
    }
  },
  created() {
    this.getDspName()
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide() {
    return {
      init: this.init
    }
  },
  methods: {
    beforeInit() {
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      this.tableUrl = '/distOppoAppConfig/list'
      return true
    },
    getDspName() {
      getDspName().then(res => {
        if (res.code === 200) {
          const arr = []
          res.data.forEach(item => {
            const obj = { value: item.dspId, label: item.dspName }
            arr.push(obj)
          })
          this.dspList = arr
        }
      })
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    add() {
      this.$refs.form.show()
    },
    configuration(row) {
      this.$refs.form.show(row)
    },
    toQuery() {
      this.tableParams.pageSize = this.pagination.pageSize
      this.tableParams.pageNum = this.pagination.pageNum
      this.init()
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ""
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ""
      }
      this.init()
    },
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
